<template>
  <div class="baiduQueue">
    <div class="box">
      <div class="b1">个人信息</div>
      <div class="b2">
        <img :src="item.avatarUrl ? item.avatarUrl : '/static/index/index16.png'" alt="" />
        <div>
          <div class="b21">
            <div class="b211">
              <div class="b2111">{{ item.nickName }}</div>
              <div class="b2112">{{ item.grade }}</div>
            </div>
            <div class="b212">{{ item.integral }}</div>
          </div>
          <div class="b22">
            <div class="b221">{{ item.telephone }}</div>
            <div class="b222">我的积分</div>
          </div>
        </div>
      </div>
      <div class="b3" @click="exit">退出登录</div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item: {},
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
      this.$axios
        .post(
          "/get_account_info",
          this.$qs.stringify({ 
            aid: Cookie.get("id"),
            access_token:sessionStorage.getItem('access_token')
          })
        )
        .then((res) => {
          this.item = res.data.data;
        });
    },
    exit() {
      this.$confirm(`确定要退出登录吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.logout()
        })
        .catch(() => { });
    },
    logout() {
      this.$axios
        .post(
          "/login_out",
          this.$qs.stringify(
            { 
            aid: Cookie.get("id"),
            access_token:sessionStorage.getItem('access_token')
          }
          )
        )
        .then((res) => {
          Cookie.set('id', '')
          Cookie.set('name', '')
          Cookie.set('level', '')
          sessionStorage.removeItem('access_token')
          this.$router.push('/login')
        });
    },
  },

  mounted() {
    this.getData();
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue {
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .box {
    width: 1200px;
    margin: 0 auto;
    height: 241px;
    background: #ffffff;
    border: 1px solid rgba(204, 204, 204, 0.5);
    position: relative;

    .b1 {
      width: calc(100% - 32px);
      height: 60px;
      background: #f3f3f3;
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      padding-left: 32px;
      line-height: 60px;
    }

    .b2 {
      width: calc(100% - 318px);
      margin: 0 auto;
      height: 180px;
      display: flex;
      align-items: center;
      padding-bottom: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 120px;
        height: 120px;
        // margin-left: 30px;
        // margin-right: 90px;
      }

      &>div {
        width: calc(100% - 160px);

        .b21 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;

          .b211 {
            display: flex;
            align-items: center;

            .b2111 {
              font-size: 24px;
              font-family: SourceHanSansCN-Bold, SourceHanSansCN;
              font-weight: bold;
              color: #333333;
              margin-right: 10px;
            }

            .b2112 {
              width: 56px;
              height: 20px;
              background: linear-gradient(92deg, #ff8f05 0%, #ff5602 100%);
              border-radius: 4px;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
            }
          }

          .b212 {
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
            width: 15%;
            text-align: center;
          }
        }

        .b22 {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .b221 {
            font-size: 18px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #666666;
          }

          .b222 {
            font-size: 18px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #666666;
            width: 15%;
            text-align: center;
          }
        }
      }
    }

    .b3 {
      width: 72px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #979797;
      text-align: center;
      line-height: 30px;
      margin-right: 20px;
      cursor: pointer;
      position: absolute;
      right: 50px;
      top: 15px;
    }
  }
}</style>  


// WEBPACK FOOTER //
// src/pages/user/index.vue